import { Component, OnInit } from '@angular/core';
import { BundleDealerService } from '../../services/bundle-dealer.service';
import { ProviderService } from '../../services/provider.service';

@Component({
  selector: 'app-pge-customer-search-modal',
  templateUrl: './pge-customer-search-modal.component.html',
  styleUrls: ['./pge-customer-search-modal.component.scss'],
})
export class PgeCustomerSearchModalComponent implements OnInit {
  constructor(public bundleDealerService: BundleDealerService, private providerService: ProviderService) {}

  ngOnInit(): void {}

  onCustomerSearch() {
    this.providerService.isPGECall && this.bundleDealerService.getPGECustomers();
    this.providerService.isUSH_Call && this.bundleDealerService.getFECustomers();
  }
}
